import { render, staticRenderFns } from "./BorderBox.vue?vue&type=template&id=9515b448&scoped=true&"
import script from "./BorderBox.vue?vue&type=script&lang=js&"
export * from "./BorderBox.vue?vue&type=script&lang=js&"
import style0 from "./BorderBox.vue?vue&type=style&index=0&id=9515b448&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9515b448",
  null
  
)

export default component.exports